var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useRef, useEffect } from "react";
import { Box, Typography, TextField, Button, Select, MenuItem, FormControl, Stack, Grid, Tab, IconButton, Accordion, AccordionSummary, AccordionDetails, Link, } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import CommonHeader from "../../components/UtilityComponents/commonHeader";
import { BackArrowIcon, BrandCustomizationIcon } from "../../components/icons";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AddIcon from "@mui/icons-material/Add";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { colors } from "../../Themes/colors";
import defaultTheme from "../../Themes/default_theme";
import FilesIcon from "../../components/icons/FilesIcon";
import RichTextEditor from "../../components/QuillEditer";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import { utility } from "../../utils";
import constants from "../../config/constants";
import ConfirmationAndInformationPoup, { POPUP_TYPE, } from "../../components/UtilityComponents/ConfirmationAndInformationPoup";
import CustomSwitch from "../../components/uiComponents/CustomSwitch";
import useCustomerPortalPermissions from "../../hooks/useCustomerPortalPermissions";
import { getCustomerPortalDisplayName } from "../../utils/commonUtilities";
var VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
});
var VisuallyHiddenColorInput = styled("input")({
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    cursor: "pointer",
});
function parseHexToRgb(hex) {
    var match = hex.replace(/^#/, "").match(/^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);
    if (!match)
        return null;
    var s = match[1];
    if (s.length === 3) {
        s = s[0] + s[0] + s[1] + s[1] + s[2] + s[2];
    }
    var r = parseInt(s.slice(0, 2), 16);
    var g = parseInt(s.slice(2, 4), 16);
    var b = parseInt(s.slice(4, 6), 16);
    return { r: r, g: g, b: b };
}
function getLuminance(hex) {
    var rgb = parseHexToRgb(hex);
    if (!rgb)
        return null;
    var r = rgb.r, g = rgb.g, b = rgb.b;
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
}
var PRIMARY_COLOR_MAX_LUMINANCE = 0.42;
function isColorTooLight(hex) {
    var lum = getLuminance(hex);
    return lum !== null && lum >= PRIMARY_COLOR_MAX_LUMINANCE;
}
function isValidPortalHostname(hostname) {
    var normalizedHostname = hostname.trim().toLowerCase();
    if (!normalizedHostname)
        return false;
    if (normalizedHostname === "localhost")
        return true;
    var ipv4Pattern = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
    if (ipv4Pattern.test(normalizedHostname)) {
        return true;
    }
    if (normalizedHostname.length > 253 ||
        normalizedHostname.startsWith(".") ||
        normalizedHostname.endsWith(".") ||
        !normalizedHostname.includes(".")) {
        return false;
    }
    var hostnameParts = normalizedHostname.split(".");
    var labelPattern = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;
    var topLevelDomain = hostnameParts[hostnameParts.length - 1];
    return (hostnameParts.every(function (part) { return labelPattern.test(part); }) &&
        /^[a-z]{2,63}$/.test(topLevelDomain));
}
function getPortalUrlValidationMessage(url) {
    var normalizedUrl = url.trim();
    if (!normalizedUrl)
        return "Portal URL is required";
    var hasProtocol = /^[a-zA-Z][a-zA-Z\d+.-]*:\/\//.test(normalizedUrl);
    if (!hasProtocol) {
        return "URL must include https://";
    }
    try {
        var parsedUrl = new URL(normalizedUrl);
        if (parsedUrl.protocol !== "https:") {
            return "HTTPS protocol required";
        }
        if (!parsedUrl.hostname || !isValidPortalHostname(parsedUrl.hostname)) {
            return "Enter a valid URL";
        }
        return "";
    }
    catch (_a) {
        return "Enter a valid URL";
    }
}
var BLOB_BASE = "https://auxcap.blob.core.windows.net/";
function getBlobBase() {
    var _a, _b, _c;
    var env = process.env.NODE_ENV === constants.ENV.PRODUCTION &&
        ((_b = (_a = process.env.API_DOMAIN) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("uat"))
        ? constants.ENV.UAT
        : ((_c = process.env.NODE_ENV) !== null && _c !== void 0 ? _c : constants.ENV.DEV);
    switch (env) {
        case constants.ENV.PRODUCTION:
            return "https://auxcapcustomerportalprod.blob.core.windows.net/";
        case constants.ENV.DEV:
        case constants.ENV.QA:
        case constants.ENV.UAT:
        default:
            return BLOB_BASE;
    }
}
function getBlobContainer() {
    var _a, _b, _c;
    var env = process.env.NODE_ENV === constants.ENV.PRODUCTION &&
        ((_b = (_a = process.env.API_DOMAIN) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("uat"))
        ? constants.ENV.UAT
        : ((_c = process.env.NODE_ENV) !== null && _c !== void 0 ? _c : constants.ENV.DEV);
    switch (env) {
        case constants.ENV.DEV:
            return "auxcap-dev-customer-portal";
        case constants.ENV.QA:
            return "auxcap-qa-customer-portal";
        case constants.ENV.UAT:
            return "auxcap-uat-customer-portal";
        case constants.ENV.PRODUCTION:
            return "auxcap-prod-customer-portal";
        default:
            return "auxcap-dev-customer-portal";
    }
}
var CustomerPortalBrandCustomization = function () {
    var _a = useState("#2563EB"), primaryColor = _a[0], setPrimaryColor = _a[1];
    var _b = useState("N/A"), companyName = _b[0], setCompanyName = _b[1];
    var _c = useState(null), logoFile = _c[0], setLogoFile = _c[1];
    var _d = useState(null), logoPreview = _d[0], setLogoPreview = _d[1];
    var _e = useState(null), favIconFile = _e[0], setFavIconFile = _e[1];
    var _f = useState(null), favIconPreview = _f[0], setFavIconPreview = _f[1];
    var _g = useState("Inter"), fontFamily = _g[0], setFontFamily = _g[1];
    var _h = useState("1"), faqTab = _h[0], setFaqTab = _h[1];
    var _j = useState(""), question = _j[0], setQuestion = _j[1];
    var _k = useState(""), answer = _k[0], setAnswer = _k[1];
    var _l = useState("1"), portalTab = _l[0], setPortalTab = _l[1];
    var _m = useState(false), isEditMode = _m[0], setIsEditMode = _m[1];
    var _o = useState(true), isReadOnly = _o[0], setIsReadOnly = _o[1];
    var _p = useState(""), selectedPortalName = _p[0], setSelectedPortalName = _p[1];
    var _q = useState(null), selectedPortalId = _q[0], setSelectedPortalId = _q[1];
    var _r = useState(""), portalUrl = _r[0], setPortalUrl = _r[1];
    var _s = useState(""), content = _s[0], setContent = _s[1];
    var _t = useState(1), brandStatus = _t[0], setBrandStatus = _t[1];
    var _u = useState(false), isPrivateLabel = _u[0], setIsPrivateLabel = _u[1];
    var _v = useState([]), faqs = _v[0], setFaqs = _v[1];
    var _w = useState(null), editingFaqId = _w[0], setEditingFaqId = _w[1];
    var _x = useState(false), isAddingFaq = _x[0], setIsAddingFaq = _x[1];
    var _y = useState([]), portalInstances = _y[0], setPortalInstances = _y[1];
    var _z = useState(false), isLoadingPortals = _z[0], setIsLoadingPortals = _z[1];
    var _0 = useState(false), deleteConfirmationOpen = _0[0], setDeleteConfirmationOpen = _0[1];
    var _1 = useState(null), pendingDeleteFaqId = _1[0], setPendingDeleteFaqId = _1[1];
    var _2 = useState(null), answerUpload = _2[0], setAnswerUpload = _2[1];
    var _3 = useState(""), existingAnswerImagePath = _3[0], setExistingAnswerImagePath = _3[1];
    var _4 = useState(""), existingLogoPath = _4[0], setExistingLogoPath = _4[1];
    var _5 = useState(""), existingFavIconPath = _5[0], setExistingFavIconPath = _5[1];
    var _6 = useState(""), primaryColorError = _6[0], setPrimaryColorError = _6[1];
    var _7 = useState(false), imageRemovedInEdit = _7[0], setImageRemovedInEdit = _7[1];
    var logoInputRef = useRef(null);
    var favIconInputRef = useRef(null);
    var cpPermissions = useCustomerPortalPermissions();
    var faqPerms = cpPermissions.faqs;
    var FAQ_FILE_MAX_SIZE_BYTES = 25 * 1024 * 1024;
    var BRAND_IMAGE_MAX_SIZE_BYTES = 5 * 1024 * 1024;
    var handlePrimaryColorChange = function (value) {
        var normalized = value.startsWith("#") ? value : "#".concat(value);
        setPrimaryColorError("");
        if (normalized.length < 4) {
            setPrimaryColor(normalized);
            return;
        }
        var rgb = parseHexToRgb(normalized);
        if (rgb === null) {
            setPrimaryColorError("Invalid color code. Please enter a valid value.");
            setPrimaryColor(normalized);
            return;
        }
        if (isColorTooLight(normalized)) {
            setPrimaryColorError("Light color selections can affect text contrast and accessibility compliance.\nPlease select colors that meet contrast guidelines.");
            return;
        }
        setPrimaryColor(normalized);
    };
    var getPlainTextLength = function (html) {
        var _a;
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return ((_a = tempDiv.textContent) === null || _a === void 0 ? void 0 : _a.length) || 0;
    };
    var preserveBulletPoints = function (html) {
        if (!html)
            return html;
        if (!html.includes("data-list=")) {
            return html;
        }
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        var olElements = tempDiv.querySelectorAll("ol");
        olElements.forEach(function (ol) {
            var _a;
            var listItems = Array.from(ol.querySelectorAll("li"));
            if (listItems.length === 0)
                return;
            var groups = [];
            var currentGroup = { type: null, items: [] };
            listItems.forEach(function (li) {
                var dataList = li.getAttribute("data-list");
                var listType = dataList === "bullet"
                    ? "bullet"
                    : dataList === "ordered"
                        ? "ordered"
                        : null;
                if (listType && listType === currentGroup.type) {
                    currentGroup.items.push(li);
                }
                else {
                    if (currentGroup.type !== null && currentGroup.items.length > 0) {
                        groups.push({
                            type: currentGroup.type,
                            items: __spreadArray([], currentGroup.items, true),
                        });
                    }
                    currentGroup = { type: listType, items: [li] };
                }
            });
            if (currentGroup.type !== null && currentGroup.items.length > 0) {
                groups.push({
                    type: currentGroup.type,
                    items: __spreadArray([], currentGroup.items, true),
                });
            }
            if (groups.length > 0) {
                var fragment_1 = document.createDocumentFragment();
                groups.forEach(function (group) {
                    var listTag = group.type === "bullet" ? "ul" : "ol";
                    var newList = document.createElement(listTag);
                    group.items.forEach(function (li) {
                        var newLi = li.cloneNode(true);
                        newLi.removeAttribute("data-list");
                        var qlUiSpans = newLi.querySelectorAll("span.ql-ui");
                        qlUiSpans.forEach(function (span) { return span.remove(); });
                        newList.appendChild(newLi);
                    });
                    fragment_1.appendChild(newList);
                });
                (_a = ol.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(fragment_1, ol);
            }
        });
        return tempDiv.innerHTML;
    };
    function getImageUrl(imagePath) {
        var _a;
        var path = (_a = imagePath === null || imagePath === void 0 ? void 0 : imagePath.trim()) !== null && _a !== void 0 ? _a : "";
        if (!path)
            return "";
        if (path.startsWith("http://") || path.startsWith("https://"))
            return path;
        var normalized = path.replace(/^\//, "");
        var container = getBlobContainer();
        var containerPath = normalized.startsWith("auxcap-")
            ? "".concat(normalized.split("/")[0], "/").concat(normalized)
            : "".concat(container, "/").concat(container, "/").concat(normalized);
        return "".concat(getBlobBase()).concat(containerPath);
    }
    var handleAddFaq = function () {
        setIsAddingFaq(true);
        setQuestion("");
        setContent("");
        setAnswerUpload(null);
        setExistingAnswerImagePath("");
    };
    var handleEditFaq = function (faq) {
        setEditingFaqId(faq.id);
        setQuestion(preserveBulletPoints(faq.question));
        setContent(preserveBulletPoints(faq.answer));
        setAnswerUpload(null);
        setExistingAnswerImagePath(faq.answerUpload || "");
        setImageRemovedInEdit(false);
    };
    var handleDeleteFaq = function (id) {
        setPendingDeleteFaqId(id);
        setDeleteConfirmationOpen(true);
    };
    var handleConfirmDeleteFaq = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_1, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!faqPerms.canDelete) {
                        utility.alert("You don't have permission to delete FAQs", constants.TOAST_TYPES.ERROR);
                        setDeleteConfirmationOpen(false);
                        setPendingDeleteFaqId(null);
                        return [2];
                    }
                    if (pendingDeleteFaqId === null || !selectedPortalId) {
                        setDeleteConfirmationOpen(false);
                        setPendingDeleteFaqId(null);
                        return [2];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 7, 8, 9]);
                    payload = {
                        id: pendingDeleteFaqId,
                        portalId: Number(selectedPortalId),
                    };
                    return [4, api_service.delete({
                            endPoint: api_urls.CUSTOMER_PORTAL_FAQ_DELETE,
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if (!((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200)) return [3, 5];
                    utility.alert(response.data.message || "FAQ deleted successfully!", constants.TOAST_TYPES.INFO);
                    if (!selectedPortalId) return [3, 4];
                    return [4, fetchFaqs(selectedPortalId)];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4: return [3, 6];
                case 5:
                    utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to delete FAQ", constants.TOAST_TYPES.ERROR);
                    _d.label = 6;
                case 6: return [3, 9];
                case 7:
                    error_1 = _d.sent();
                    console.error("Error deleting FAQ:", error_1);
                    errorMessage = ((_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) ||
                        "Failed to delete FAQ";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 9];
                case 8:
                    setDeleteConfirmationOpen(false);
                    setPendingDeleteFaqId(null);
                    return [7];
                case 9: return [2];
            }
        });
    }); };
    var handleCancelDeleteFaq = function () {
        setDeleteConfirmationOpen(false);
        setPendingDeleteFaqId(null);
    };
    var hasTextContent = function (html) {
        if (!html || !html.trim())
            return false;
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        var textContent = tempDiv.textContent || tempDiv.innerText || "";
        return textContent.trim().length > 0;
    };
    var handleSaveFaq = function () { return __awaiter(void 0, void 0, void 0, function () {
        var formData, processedContent, response, error_2, errorMessage, formData, processedContent, response, error_3, errorMessage;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!hasTextContent(question)) {
                        utility.alert("Question is required", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (!hasTextContent(content)) {
                        utility.alert("Answer is required", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (answerUpload && answerUpload.size > FAQ_FILE_MAX_SIZE_BYTES) {
                        utility.alert("File size exceeds 25 MB limit. Please upload a smaller file.", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (!isAddingFaq) return [3, 9];
                    if (!faqPerms.canCreate) {
                        utility.alert("You don't have permission to add FAQs", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (!selectedPortalId) {
                        utility.alert("Portal ID is required. Please select a portal first.", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 7, , 8]);
                    formData = new FormData();
                    formData.append("portalId", String(selectedPortalId));
                    formData.append("question", preserveBulletPoints(question.trim()));
                    processedContent = preserveBulletPoints(content.trim() || " ");
                    formData.append("answer", processedContent);
                    if (answerUpload) {
                        formData.append("answerImage", answerUpload);
                    }
                    else {
                        formData.append("answerImage", "");
                    }
                    return [4, api_service.post({
                            endPoint: api_urls.CUSTOMER_PORTAL_FAQ_CREATE,
                            headerType: api_service.ContentHeaders.FormData,
                            payLoad: formData,
                            showLoader: true,
                        })];
                case 2:
                    response = _g.sent();
                    if (!((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200)) return [3, 5];
                    utility.alert(response.data.message || "FAQ created successfully!", constants.TOAST_TYPES.INFO);
                    if (!selectedPortalId) return [3, 4];
                    return [4, fetchFaqs(selectedPortalId)];
                case 3:
                    _g.sent();
                    _g.label = 4;
                case 4:
                    setIsAddingFaq(false);
                    setQuestion("");
                    setContent("");
                    setAnswerUpload(null);
                    return [3, 6];
                case 5:
                    utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to create FAQ", constants.TOAST_TYPES.ERROR);
                    _g.label = 6;
                case 6: return [3, 8];
                case 7:
                    error_2 = _g.sent();
                    console.error("Error creating FAQ:", error_2);
                    errorMessage = ((_c = (_b = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) ||
                        "Failed to create FAQ";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 8];
                case 8: return [3, 17];
                case 9:
                    if (!(editingFaqId !== null)) return [3, 17];
                    if (!faqPerms.canEdit) {
                        utility.alert("You don't have permission to edit FAQs", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (!selectedPortalId) {
                        utility.alert("Portal ID is required. Please select a portal first.", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    _g.label = 10;
                case 10:
                    _g.trys.push([10, 16, , 17]);
                    formData = new FormData();
                    formData.append("portalId", String(selectedPortalId));
                    formData.append("question", preserveBulletPoints(question.trim()));
                    processedContent = preserveBulletPoints(content.trim());
                    formData.append("answer", processedContent);
                    formData.append("id", String(editingFaqId));
                    if (answerUpload) {
                        formData.append("answerImage", answerUpload);
                    }
                    else if (imageRemovedInEdit) {
                        formData.append("answerImage", "");
                    }
                    else if (!existingAnswerImagePath) {
                        formData.append("answerImage", "");
                    }
                    return [4, api_service.patch({
                            endPoint: api_urls.CUSTOMER_PORTAL_FAQ_UPDATE,
                            headerType: api_service.ContentHeaders.FormData,
                            payLoad: formData,
                            showLoader: true,
                        })];
                case 11:
                    response = _g.sent();
                    if (!((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200)) return [3, 14];
                    utility.alert(response.data.message || "FAQ updated successfully!", constants.TOAST_TYPES.INFO);
                    if (!selectedPortalId) return [3, 13];
                    return [4, fetchFaqs(selectedPortalId)];
                case 12:
                    _g.sent();
                    _g.label = 13;
                case 13:
                    setEditingFaqId(null);
                    setQuestion("");
                    setContent("");
                    setAnswerUpload(null);
                    setExistingAnswerImagePath("");
                    setImageRemovedInEdit(false);
                    return [3, 15];
                case 14:
                    utility.alert(((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.message) || "Failed to update FAQ", constants.TOAST_TYPES.ERROR);
                    _g.label = 15;
                case 15: return [3, 17];
                case 16:
                    error_3 = _g.sent();
                    console.error("Error updating FAQ:", error_3);
                    errorMessage = ((_f = (_e = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) ||
                        (error_3 === null || error_3 === void 0 ? void 0 : error_3.message) ||
                        "Failed to update FAQ";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 17];
                case 17: return [2];
            }
        });
    }); };
    var handleCancelEdit = function () {
        setEditingFaqId(null);
        setIsAddingFaq(false);
        setQuestion("");
        setContent("");
        setAnswerUpload(null);
        setExistingAnswerImagePath("");
        setImageRemovedInEdit(false);
    };
    var FAQ_FILE_ALLOWED_TYPES = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "image/webp",
        "application/pdf",
    ];
    var handleAnswerUpload = function (event) {
        var _a, _b, _c;
        var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        var input = event.target;
        if (!file)
            return;
        if (file.size > FAQ_FILE_MAX_SIZE_BYTES) {
            utility.alert("File size exceeds 25 MB limit. Please upload a smaller file.", constants.TOAST_TYPES.ERROR);
            input.value = "";
            return;
        }
        var allowedTypes = FAQ_FILE_ALLOWED_TYPES;
        var fileType = (_b = file.type) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        var fileExtension = (_c = file.name.split(".").pop()) === null || _c === void 0 ? void 0 : _c.toLowerCase();
        var isAllowedType = allowedTypes.includes(fileType) ||
            ["jpg", "jpeg", "png", "gif", "webp", "pdf"].includes(fileExtension || "");
        if (!isAllowedType) {
            utility.alert("Invalid file type. Allowed: JPG, PNG, GIF, WebP, or PDF.", constants.TOAST_TYPES.ERROR);
            input.value = "";
            return;
        }
        setAnswerUpload(file);
        setExistingAnswerImagePath("");
        if (editingFaqId !== null) {
            setImageRemovedInEdit(true);
        }
        input.value = "";
    };
    var fetchBrands = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, apiResponse, error_4, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setIsLoadingPortals(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_BRAND_LIST,
                            payLoad: {},
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        apiResponse = response.data;
                        setPortalInstances(apiResponse.data || []);
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch portal instances", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 5];
                case 3:
                    error_4 = _d.sent();
                    console.error("Error fetching portal instances:", error_4);
                    errorMessage = ((_c = (_b = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_4 === null || error_4 === void 0 ? void 0 : error_4.message) ||
                        "Failed to fetch portal instances";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 5];
                case 4:
                    setIsLoadingPortals(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    useEffect(function () {
        setIsAddingFaq(false);
        setQuestion("");
        setContent("");
        setAnswerUpload(null);
        fetchBrands();
    }, []);
    var fetchBrandData = function (brandId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, brandData, colorValue, hexColor, colorMap, fontOptions_1, fontId, fontIndex, fullLogoUrl, favIconValue, error_5, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!brandId)
                        return [2];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 7, , 8]);
                    return [4, api_service.get({
                            endPoint: "".concat(api_urls.CUSTOMER_PORTAL_BRAND_GET_BY_ID, "/").concat(brandId),
                            payLoad: {},
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if (!((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200)) return [3, 5];
                    brandData = response.data.data;
                    if (brandData.CompanyName) {
                        setCompanyName(brandData.CompanyName);
                    }
                    setPrimaryColorError("");
                    if (brandData.PrimaryColour) {
                        colorValue = brandData.PrimaryColour;
                        hexColor = void 0;
                        if (colorValue.startsWith("#")) {
                            hexColor = colorValue;
                        }
                        else {
                            colorMap = {
                                Blue: "#2563EB",
                                Red: "#DC2626",
                                Green: "#16A34A",
                                Yellow: "#EAB308",
                                Purple: "#9333EA",
                                Pink: "#EC4899",
                                Orange: "#EA580C",
                                Black: "#000000",
                                White: "#FFFFFF",
                            };
                            hexColor = colorMap[colorValue] || colorValue || "#2563EB";
                        }
                        setPrimaryColor(isColorTooLight(hexColor) ? "#2563EB" : hexColor);
                    }
                    else {
                        setPrimaryColor("#2563EB");
                    }
                    if (brandData.Font) {
                        fontOptions_1 = [
                            "Inter",
                            "Roboto",
                            "Open Sans",
                            "Lato",
                            "Montserrat",
                            "Poppins",
                        ];
                        fontId = String(brandData.Font);
                        fontIndex = parseInt(fontId) - 1;
                        if (fontIndex >= 0 && fontIndex < fontOptions_1.length) {
                            setFontFamily(fontOptions_1[fontIndex]);
                        }
                        else {
                            setFontFamily(fontOptions_1.includes(fontId) ? fontId : "Inter");
                        }
                    }
                    else {
                        setFontFamily("Inter");
                    }
                    if (brandData.PortalUrl) {
                        setPortalUrl(brandData.PortalUrl);
                    }
                    else {
                        setPortalUrl("");
                    }
                    if (brandData.Logo &&
                        typeof brandData.Logo === "string" &&
                        brandData.Logo.trim() !== "") {
                        setExistingLogoPath(brandData.Logo);
                        if (brandData.Logo.startsWith("http") ||
                            brandData.Logo.startsWith("/") ||
                            brandData.Logo.startsWith("data:")) {
                            setLogoPreview(brandData.Logo);
                        }
                        else {
                            fullLogoUrl = getImageUrl(brandData.Logo);
                            setLogoPreview(fullLogoUrl);
                        }
                        setLogoFile(null);
                    }
                    else {
                        setExistingLogoPath("");
                        setLogoPreview(null);
                        setLogoFile(null);
                    }
                    favIconValue = brandData.FavLogo ||
                        brandData.favLogo ||
                        brandData.FavIcon ||
                        brandData.Favicon ||
                        brandData.FavIconUrl ||
                        brandData.FaviconUrl ||
                        brandData.favIcon ||
                        brandData.favicon ||
                        "";
                    if (favIconValue &&
                        typeof favIconValue === "string" &&
                        favIconValue.trim() !== "") {
                        setExistingFavIconPath(favIconValue);
                        if (favIconValue.startsWith("http") ||
                            favIconValue.startsWith("/") ||
                            favIconValue.startsWith("data:")) {
                            setFavIconPreview(favIconValue);
                        }
                        else {
                            setFavIconPreview(getImageUrl(favIconValue));
                        }
                        setFavIconFile(null);
                    }
                    else {
                        setExistingFavIconPath("");
                        setFavIconPreview(null);
                        setFavIconFile(null);
                    }
                    if (brandData.PortalName) {
                        setSelectedPortalName(brandData.PortalName);
                    }
                    if (brandData.status !== undefined) {
                        setBrandStatus(brandData.status);
                    }
                    if (brandData.IsPrivateLabel !== undefined) {
                        setIsPrivateLabel(Boolean(brandData.IsPrivateLabel));
                    }
                    else {
                        setIsPrivateLabel(false);
                    }
                    if (!brandId) return [3, 4];
                    setIsAddingFaq(false);
                    setQuestion("");
                    setContent("");
                    setAnswerUpload(null);
                    return [4, fetchFaqs(Number(brandId))];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4: return [2, brandData];
                case 5:
                    utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch brand data", constants.TOAST_TYPES.ERROR);
                    return [2, null];
                case 6: return [3, 8];
                case 7:
                    error_5 = _d.sent();
                    console.error("Error fetching brand data:", error_5);
                    errorMessage = ((_c = (_b = error_5 === null || error_5 === void 0 ? void 0 : error_5.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_5 === null || error_5 === void 0 ? void 0 : error_5.message) ||
                        "Failed to fetch brand data";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [2, null];
                case 8: return [2];
            }
        });
    }); };
    var fetchFaqs = function (portalId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, apiResponse, transformedFaqs, error_6, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!portalId)
                        return [2];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_FAQ_LIST,
                            payLoad: {
                                portalId: Number(portalId),
                            },
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        apiResponse = response.data;
                        transformedFaqs = (apiResponse.data || []).map(function (faq) { return ({
                            id: Number(faq.Id),
                            question: faq.Question || "",
                            answer: preserveBulletPoints(faq.Answer || ""),
                            answerUpload: faq.ImageUrl || "",
                        }); });
                        setFaqs(transformedFaqs);
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to fetch FAQs", constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 4];
                case 3:
                    error_6 = _d.sent();
                    console.error("Error fetching FAQs:", error_6);
                    errorMessage = ((_c = (_b = error_6 === null || error_6 === void 0 ? void 0 : error_6.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_6 === null || error_6 === void 0 ? void 0 : error_6.message) ||
                        "Failed to fetch FAQs";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var handleColorChange = function (event) {
        handlePrimaryColorChange(event.target.value);
    };
    var handleTabChange = function (event, newValue) {
        setFaqTab(newValue);
        setIsAddingFaq(false);
        setEditingFaqId(null);
        setQuestion("");
        setContent("");
        setAnswerUpload(null);
        setExistingAnswerImagePath("");
        setImageRemovedInEdit(false);
    };
    var handleLogoUpload = function (event) {
        var _a, _b;
        var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            var allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
            var fileType = file.type.toLowerCase();
            var fileExtension = (_b = file.name.split(".").pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
            if (!allowedTypes.includes(fileType) &&
                !["jpg", "jpeg", "png"].includes(fileExtension || "")) {
                utility.alert("Only JPG and PNG formats are allowed for logo upload", constants.TOAST_TYPES.ERROR);
                event.target.value = "";
                return;
            }
            if (file.size > BRAND_IMAGE_MAX_SIZE_BYTES) {
                utility.alert("File size exceeds 5MB limit. Please upload a smaller file.", constants.TOAST_TYPES.ERROR);
                event.target.value = "";
                return;
            }
            setLogoFile(file);
            var reader_1 = new FileReader();
            reader_1.onloadend = function () {
                setLogoPreview(reader_1.result);
            };
            reader_1.readAsDataURL(file);
        }
    };
    var handleFavIconUpload = function (event) {
        var _a, _b;
        var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        var allowedTypes = [
            "image/png",
            "image/x-icon",
            "image/vnd.microsoft.icon",
            "image/ico",
        ];
        var fileType = (file.type || "").toLowerCase();
        var fileExtension = (_b = file.name.split(".").pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        var isAllowed = allowedTypes.includes(fileType) || ["png", "ico"].includes(fileExtension || "");
        if (!isAllowed) {
            utility.alert("Only PNG and ICO formats are allowed for Browsericon upload", constants.TOAST_TYPES.ERROR);
            event.target.value = "";
            return;
        }
        if (file.size > BRAND_IMAGE_MAX_SIZE_BYTES) {
            utility.alert("File size exceeds 5MB limit. Please upload a smaller file.", constants.TOAST_TYPES.ERROR);
            event.target.value = "";
            return;
        }
        setFavIconFile(file);
        var reader = new FileReader();
        reader.onloadend = function () {
            setFavIconPreview(reader.result);
        };
        reader.readAsDataURL(file);
    };
    var handleFontChange = function (event) {
        setFontFamily(event.target.value);
    };
    var fontOptions = [
        "Inter",
        "Roboto",
        "Open Sans",
        "Lato",
        "Montserrat",
        "Poppins",
    ];
    var formatFontFamily = function (fontName) {
        if (fontName.includes(" ")) {
            return "\"".concat(fontName, "\", sans-serif");
        }
        return "".concat(fontName, ", sans-serif");
    };
    var getFontId = function (fontName) {
        var fontIndex = fontOptions.indexOf(fontName);
        return fontIndex >= 0 ? String(fontIndex + 1) : "1";
    };
    var getColorName = function (hexColor) {
        var colorMap = {
            "#2563EB": "Blue",
            "#DC2626": "Red",
            "#16A34A": "Green",
            "#EAB308": "Yellow",
            "#9333EA": "Purple",
            "#EC4899": "Pink",
            "#EA580C": "Orange",
            "#000000": "Black",
            "#FFFFFF": "White",
        };
        return colorMap[hexColor] || hexColor;
    };
    var handleSaveBrandChanges = function () { return __awaiter(void 0, void 0, void 0, function () {
        var normalizedPortalUrl, portalUrlValidationMessage, isPrivateLabelStatus, formData, response, error_7, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!cpPermissions.brandCustomization.canEdit) {
                        utility.alert("You don't have permission to edit Brand Customization", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    if (!selectedPortalId) {
                        utility.alert("Portal ID is required", constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    normalizedPortalUrl = portalUrl.trim();
                    setPortalUrl(normalizedPortalUrl);
                    portalUrlValidationMessage = getPortalUrlValidationMessage(normalizedPortalUrl);
                    if (portalUrlValidationMessage) {
                        utility.alert(portalUrlValidationMessage, constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 8, , 9]);
                    isPrivateLabelStatus = isPrivateLabel ? 1 : 0;
                    formData = new FormData();
                    formData.append("id", String(selectedPortalId));
                    formData.append("portalName", selectedPortalName || "");
                    formData.append("primaryColour", getColorName(primaryColor));
                    formData.append("font", getFontId(fontFamily));
                    formData.append("status", String(brandStatus));
                    formData.append("portalUrl", normalizedPortalUrl || "");
                    formData.append("isPrivateLabel", isPrivateLabelStatus);
                    if (logoFile) {
                        formData.append("logo", logoFile);
                    }
                    else if (!existingLogoPath) {
                        formData.append("logo", "");
                    }
                    if (favIconFile) {
                        formData.append("favLogo", favIconFile);
                    }
                    else if (!existingFavIconPath) {
                        formData.append("favLogo", "");
                    }
                    return [4, api_service.patch({
                            endPoint: api_urls.CUSTOMER_PORTAL_BRAND_UPDATE,
                            headerType: api_service.ContentHeaders.FormData,
                            payLoad: formData,
                            showLoader: true,
                        })];
                case 2:
                    response = _d.sent();
                    if (!((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200)) return [3, 6];
                    utility.alert(response.data.message || "Brand updated successfully!", constants.TOAST_TYPES.INFO);
                    setIsReadOnly(true);
                    if (!selectedPortalId) return [3, 4];
                    return [4, fetchBrandData(selectedPortalId)];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4: return [4, fetchBrands()];
                case 5:
                    _d.sent();
                    return [3, 7];
                case 6:
                    utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to update brand", constants.TOAST_TYPES.ERROR);
                    _d.label = 7;
                case 7: return [3, 9];
                case 8:
                    error_7 = _d.sent();
                    console.error("Error updating brand:", error_7);
                    errorMessage = ((_c = (_b = error_7 === null || error_7 === void 0 ? void 0 : error_7.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_7 === null || error_7 === void 0 ? void 0 : error_7.message) ||
                        "Failed to update brand";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [3, 9];
                case 9: return [2];
            }
        });
    }); };
    return (React.createElement(Box, { sx: { p: 3, bgcolor: "#f5f5f5" } },
        React.createElement(Box, null, !isEditMode ? (React.createElement(CommonHeader, { mainTitle: "Brand Customization", subTitle: "Adjust logos, colors, and FAQ's to match your brand.", icon: React.createElement(BrandCustomizationIcon, { sx: { "& svg": { height: 24, width: 24 }, height: 24 } }) })) : (React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between" },
            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2 },
                React.createElement(IconButton, { sx: {
                        bgcolor: colors.creamPreset[20],
                        borderRadius: "50%",
                        cursor: "pointer",
                        "&:hover": { bgcolor: colors.creamPreset[20] },
                    }, onClick: function () {
                        setIsEditMode(false);
                        setIsReadOnly(true);
                        setSelectedPortalId(null);
                        setPrimaryColor("#2563EB");
                        setFontFamily("Inter");
                        setPortalUrl("");
                        setLogoFile(null);
                        setIsAddingFaq(false);
                        setQuestion("");
                        setContent("");
                        setAnswerUpload(null);
                        setLogoPreview(null);
                        setFavIconFile(null);
                        setFavIconPreview(null);
                        setIsPrivateLabel(false);
                        setFaqs([]);
                        if (logoInputRef.current)
                            logoInputRef.current.value = "";
                        if (favIconInputRef.current)
                            favIconInputRef.current.value = "";
                    } },
                    React.createElement(BackArrowIcon, null)),
                React.createElement(Stack, null,
                    React.createElement(Typography, { variant: "h6", sx: { fontWeight: 600 } }, getCustomerPortalDisplayName(selectedPortalName)),
                    React.createElement(Typography, { variant: "caption", color: "text.secondary" }, isReadOnly ? "Viewing Brand Settings" : "Editing Brand Settings"))),
            isReadOnly && faqTab === "1" && cpPermissions.brandCustomization.canEdit && (React.createElement(Button, { variant: "contained", startIcon: React.createElement(EditOutlinedIcon, null), sx: { textTransform: "none" }, onClick: function () { return setIsReadOnly(false); }, title: "Edit Brand Customization Settings" }, "Edit"))))),
        React.createElement(Stack, { mt: 3 }, !isEditMode ? (React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: "body1", sx: { fontWeight: 600, mb: 2 } }, "Portal Instances"),
            React.createElement(Stack, { sx: {
                    bgcolor: "white",
                    borderRadius: 2,
                    padding: 3,
                } },
                React.createElement(Stack, { sx: { gap: 2 } }, isLoadingPortals ? (React.createElement(Typography, { variant: "body2", sx: { textAlign: "center", py: 3 } }, "Loading portal instances...")) : portalInstances.length === 0 ? (React.createElement(Typography, { variant: "body2", sx: { textAlign: "center", py: 3 } }, "No portal instances found")) : (portalInstances.map(function (portal, index) { return (React.createElement(Stack, { key: portal.id || portal.Id || index, sx: {
                        bgcolor: "white",
                        borderRadius: 2,
                        p: 2,
                        border: "1px solid ".concat(colors.greyShades[18]),
                    } },
                    React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", spacing: 2 },
                        React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1.5, flex: 1 },
                            React.createElement(Box, { sx: {
                                    width: 44,
                                    height: 44,
                                    bgcolor: "#EDDDB0",
                                    borderRadius: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                } },
                                React.createElement(FilesIcon, null)),
                            React.createElement(Box, { flex: 1 },
                                React.createElement(Typography, { variant: "body2", sx: { fontWeight: 600, mb: 0.5 } }, getCustomerPortalDisplayName(portal.PortalName)),
                                React.createElement(Typography, { variant: "body2", color: "text.secondary", fontWeight: 600 },
                                    "Portal URL:",
                                    React.createElement(Link, { href: portal.portalUrl ||
                                            portal.description ||
                                            portal.PortalUrl ||
                                            portal.URL ||
                                            "#", target: "_blank", rel: "noopener noreferrer", sx: {
                                            ml: 0.5,
                                            fontSize: 14,
                                            color: "".concat(colors.blueShades[10], " !important"),
                                            textDecoration: "underline",
                                            "&:hover": {
                                                color: colors.blueShades[11],
                                                textDecoration: "underline",
                                            },
                                        } }, portal.PortalUrl || "N/A")))),
                        cpPermissions.brandCustomization.canView && (React.createElement(Button, { variant: "outlined", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var portalId, portalName;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            portalId = portal.id || portal.Id;
                                            portalName = portal.title || portal.Name || portal.BrandName || "Portal ".concat(index + 1);
                                            setSelectedPortalName(portalName);
                                            setSelectedPortalId(portalId || null);
                                            setIsReadOnly(true);
                                            setIsEditMode(true);
                                            if (!portalId) return [3, 2];
                                            return [4, fetchBrandData(portalId)];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2: return [2];
                                    }
                                });
                            }); }, sx: { textTransform: "none", borderRadius: 1 } }, "View & Edit"))))); })))))) : (React.createElement(Stack, { sx: { bgcolor: colors.fullWhite, borderRadius: 2 } },
            React.createElement(TabContext, { value: faqTab },
                React.createElement(Box, { sx: { borderBottom: 1, borderColor: "divider" } },
                    React.createElement(TabList, { onChange: handleTabChange },
                        React.createElement(Tab, { label: "Brand Customization", value: "1", sx: { textTransform: "none" } }),
                        React.createElement(Tab, { label: "FAQs", value: "2", sx: { textTransform: "none" } }))),
                React.createElement(TabPanel, { value: "1" },
                    React.createElement(Stack, null,
                        React.createElement(Grid, { container: true, spacing: 3 },
                            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                                React.createElement(Stack, { sx: { gap: 2 } },
                                    React.createElement(Box, null,
                                        React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2 },
                                            React.createElement(Typography, { sx: { fontSize: 12, fontWeight: 600 } }, "Private Label"),
                                            React.createElement(CustomSwitch, { checked: isPrivateLabel, onChange: function (e) {
                                                    return setIsPrivateLabel(e.target.checked);
                                                }, activeColor: defaultTheme.palette.primary.main, disabled: isReadOnly }))),
                                    React.createElement(Box, null,
                                        React.createElement(Typography, { sx: { fontSize: 12, fontWeight: 600 } }, "Company Name"),
                                        React.createElement(Stack, { direction: "row", spacing: 2, alignItems: "center" },
                                            React.createElement(Stack, { width: "100%" },
                                                React.createElement(TextField, { fullWidth: true, size: "small", disabled: true, value: companyName })))),
                                    React.createElement(Box, null,
                                        React.createElement(Typography, { sx: { fontSize: 12, fontWeight: 600 } }, "Primary Color"),
                                        React.createElement(Stack, { direction: "row", spacing: 2, alignItems: "center" },
                                            React.createElement(Stack, { width: "100%" },
                                                React.createElement(TextField, { fullWidth: true, size: "small", value: primaryColor, onChange: function (e) {
                                                        return handlePrimaryColorChange(e.target.value);
                                                    }, onPaste: function (e) {
                                                        var _a;
                                                        e.preventDefault();
                                                        var pasted = (((_a = e.clipboardData) === null || _a === void 0 ? void 0 : _a.getData("text")) || "").trim();
                                                        handlePrimaryColorChange(pasted);
                                                    }, inputProps: {
                                                        pattern: "^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$",
                                                        maxLength: 7,
                                                    }, disabled: isReadOnly })),
                                            React.createElement(Box, { component: "label", sx: {
                                                    width: 150,
                                                    height: 40,
                                                    bgcolor: primaryColor,
                                                    borderRadius: 2,
                                                    border: "2px solid #A1AFA5",
                                                    flexShrink: 0,
                                                    position: "relative",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                } },
                                                React.createElement(VisuallyHiddenColorInput, { type: "color", value: primaryColor, disabled: isReadOnly, onChange: function (e) {
                                                        return handlePrimaryColorChange(e.target.value);
                                                    } }))),
                                        primaryColorError && (React.createElement(Typography, { variant: "caption", sx: {
                                                color: "error.main",
                                                fontSize: 12,
                                                mt: 0.5,
                                                display: "block",
                                            } }, primaryColorError))),
                                    React.createElement(Stack, null,
                                        React.createElement(Typography, { fontSize: 12, fontWeight: 600 }, "Portal URL"),
                                        React.createElement(TextField, { placeholder: "Enter Portal URL", fullWidth: true, size: "small", value: portalUrl, onChange: function (e) { return setPortalUrl(e.target.value); }, onBlur: function (e) { return setPortalUrl(e.target.value.trim()); }, disabled: isReadOnly })),
                                    React.createElement(Box, null,
                                        React.createElement(Typography, { sx: { fontSize: 12, fontWeight: 600, mb: 0.5 } }, "Font Family"),
                                        React.createElement(FormControl, { fullWidth: true, size: "small" },
                                            React.createElement(Select, { value: fontFamily, onChange: handleFontChange, displayEmpty: true, disabled: isReadOnly, sx: {
                                                    "& .MuiSelect-select": {
                                                        fontFamily: formatFontFamily(fontFamily),
                                                    },
                                                } }, fontOptions.map(function (font) { return (React.createElement(MenuItem, { key: font, value: font, sx: {
                                                    fontFamily: formatFontFamily(font),
                                                    fontSize: 14
                                                } }, font)); })))),
                                    !isReadOnly && (React.createElement(Stack, { direction: "row", spacing: 2 },
                                        React.createElement(Button, { variant: "outlined", onClick: function () {
                                                setIsReadOnly(true);
                                                setPrimaryColorError("");
                                            }, sx: {
                                                textTransform: "none",
                                                borderColor: colors.greyShades[18],
                                                color: "text.primary",
                                            } }, "Cancel"),
                                        React.createElement(Button, { variant: "contained", sx: { textTransform: "none" }, onClick: handleSaveBrandChanges, disabled: !!primaryColorError || !cpPermissions.brandCustomization.canEdit, title: !cpPermissions.brandCustomization.canEdit ? "Update permission required to save" : primaryColorError ? "Fix color error before saving" : "Save Brand Customization changes" }, "Save Changes"))))),
                            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                                React.createElement(Stack, { justifyContent: "center", height: "100%", sx: {
                                        bgcolor: colors.greyShades[14],
                                        border: "1px dashed #C9D1CB",
                                        borderRadius: 2,
                                    } },
                                    React.createElement(Box, { sx: {
                                            p: 4,
                                            textAlign: "center",
                                        } },
                                        React.createElement(Grid, { container: true, spacing: 3 },
                                            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                                                React.createElement(Typography, { sx: {
                                                        fontSize: 20,
                                                        fontWeight: 600,
                                                        mb: 1,
                                                        color: defaultTheme.palette.primary.main,
                                                    } }, "Logo"),
                                                React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 1 } }, "Upload your company or brand logo."),
                                                React.createElement(Button, { component: "label", variant: "contained", startIcon: React.createElement(CloudUploadIcon, null), disabled: isReadOnly },
                                                    "Upload Logo",
                                                    React.createElement(VisuallyHiddenInput, { type: "file", accept: "image/jpeg,image/jpg,image/png,.jpg,.jpeg,.png", onChange: handleLogoUpload, ref: logoInputRef })),
                                                (logoFile || existingLogoPath) && (React.createElement(Stack, { direction: "row", spacing: 0.5, alignItems: "center", justifyContent: "center", sx: { mt: 1 } },
                                                    React.createElement(Typography, { variant: "caption" }, logoFile ? logoFile.name : existingLogoPath),
                                                    !isReadOnly && React.createElement(IconButton, { size: "small", onClick: function () {
                                                            setLogoFile(null);
                                                            setLogoPreview(null);
                                                            setExistingLogoPath("");
                                                            if (logoInputRef.current) {
                                                                logoInputRef.current.value = "";
                                                            }
                                                        }, sx: { p: 0.5 } },
                                                        React.createElement(CloseIcon, { fontSize: "small" })))),
                                                logoPreview && (React.createElement(Box, { sx: {
                                                        mt: 2,
                                                        display: "flex",
                                                        justifyContent: "center",
                                                    } },
                                                    React.createElement("img", { src: logoPreview, alt: "Logo preview", style: {
                                                            maxWidth: "200px",
                                                            maxHeight: "200px",
                                                            borderRadius: "8px",
                                                            border: "1px solid ".concat(colors.greyShades[18]),
                                                            objectFit: "contain",
                                                        } })))),
                                            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                                                React.createElement(Typography, { sx: {
                                                        fontSize: 20,
                                                        fontWeight: 600,
                                                        mb: 1,
                                                        color: defaultTheme.palette.primary.main,
                                                    } }, "Browser Icon"),
                                                React.createElement(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 1 } }, "Upload a Icon (PNG/ICO)."),
                                                React.createElement(Button, { component: "label", variant: "contained", startIcon: React.createElement(CloudUploadIcon, null), disabled: isReadOnly },
                                                    "Upload Browser Icon",
                                                    React.createElement(VisuallyHiddenInput, { type: "file", accept: "image/png,image/x-icon,image/vnd.microsoft.icon,.png,.ico", onChange: handleFavIconUpload, ref: favIconInputRef })),
                                                (favIconFile || existingFavIconPath) && (React.createElement(Stack, { direction: "row", spacing: 0.5, alignItems: "center", justifyContent: "center", sx: { mt: 1 } },
                                                    React.createElement(Typography, { variant: "caption" }, favIconFile ? favIconFile.name : existingFavIconPath),
                                                    !isReadOnly && React.createElement(IconButton, { size: "small", onClick: function () {
                                                            setFavIconFile(null);
                                                            setFavIconPreview(null);
                                                            setExistingFavIconPath("");
                                                            if (favIconInputRef.current) {
                                                                favIconInputRef.current.value = "";
                                                            }
                                                        }, sx: { p: 0.5 } },
                                                        React.createElement(CloseIcon, { fontSize: "small" })))),
                                                favIconPreview && (React.createElement(Box, { sx: {
                                                        mt: 2,
                                                        display: "flex",
                                                        justifyContent: "center",
                                                    } },
                                                    React.createElement("img", { src: favIconPreview, alt: "Browser icon preview", style: {
                                                            width: "64px",
                                                            height: "64px",
                                                            borderRadius: "8px",
                                                            border: "1px solid ".concat(colors.greyShades[18]),
                                                            objectFit: "contain",
                                                        } }))))))))))),
                React.createElement(TabPanel, { value: "2" },
                    React.createElement(Stack, { sx: { gap: 2 } },
                        React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center" },
                            React.createElement(Typography, { variant: "body1", fontWeight: 600 }, "FAQ Management"),
                            faqPerms.canView && faqPerms.canCreate && (React.createElement(Button, { variant: "contained", startIcon: React.createElement(AddIcon, null), sx: { textTransform: "none" }, onClick: handleAddFaq }, "Add FAQ"))),
                        isAddingFaq && (React.createElement(Stack, { sx: {
                                border: "1px dashed ".concat(colors.greyShades[18]),
                                borderRadius: 2,
                                p: 2,
                                gap: 2,
                            } },
                            React.createElement(Stack, { spacing: 0.5 },
                                React.createElement(Typography, { fontSize: 14, fontWeight: 500 },
                                    "Question ",
                                    React.createElement("span", { style: { color: "red" } }, "*")),
                                React.createElement(RichTextEditor, { value: question, maxLength: 200, onChange: function (html) {
                                        var plainTextLength = getPlainTextLength(html);
                                        if (plainTextLength <= 200) {
                                            setQuestion(html);
                                        }
                                    } }),
                                React.createElement(Typography, { fontSize: 12, color: "text.secondary", textAlign: "right" },
                                    getPlainTextLength(question),
                                    " / 200 characters")),
                            React.createElement(Stack, { spacing: 0.5 },
                                React.createElement(Typography, { fontSize: 14, fontWeight: 500 },
                                    "Answer ",
                                    React.createElement("span", { style: { color: "red" } }, "*")),
                                React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center", justifyContent: "flex-end", sx: { mb: 1 } },
                                    (answerUpload || existingAnswerImagePath) && (React.createElement(Stack, { direction: "row", spacing: 0.5, alignItems: "center" },
                                        React.createElement(Typography, { variant: "caption" }, answerUpload
                                            ? answerUpload.name
                                            : existingAnswerImagePath),
                                        React.createElement(IconButton, { size: "small", onClick: function () {
                                                setAnswerUpload(null);
                                                setExistingAnswerImagePath("");
                                                if (editingFaqId !== null) {
                                                    setImageRemovedInEdit(true);
                                                }
                                            }, sx: { p: 0.5 } },
                                            React.createElement(CloseIcon, { fontSize: "small" })))),
                                    React.createElement(Stack, { spacing: 0.25, alignItems: "flex-end" },
                                        React.createElement(Button, { component: "label", variant: "outlined", startIcon: React.createElement(CloudUploadIcon, null), sx: { textTransform: "none" } },
                                            "Upload File",
                                            React.createElement(VisuallyHiddenInput, { type: "file", accept: "image/*", multiple: false, onChange: handleAnswerUpload })),
                                        React.createElement(Typography, { variant: "caption", color: "text.secondary", sx: { textAlign: "right" } }, "Supported: JPG, PNG (25MB max)"))),
                                React.createElement(RichTextEditor, { value: content, maxLength: 2000, onChange: function (html) {
                                        console.log("RichTextEditor onChange - HTML:", html);
                                        var plainTextLength = getPlainTextLength(html);
                                        if (plainTextLength <= 2000) {
                                            setContent(html);
                                        }
                                    } }),
                                React.createElement(Typography, { fontSize: 12, color: getPlainTextLength(content) > 2000
                                        ? "error"
                                        : "text.secondary", textAlign: "right", sx: { mt: 1 } },
                                    getPlainTextLength(content),
                                    " / 2000 characters"),
                                (answerUpload || existingAnswerImagePath) && (React.createElement(Box, { sx: { mb: 1 } },
                                    React.createElement("img", { src: answerUpload
                                            ? URL.createObjectURL(answerUpload)
                                            : getImageUrl(existingAnswerImagePath), alt: "FAQ attachment preview", style: {
                                            maxWidth: "200px",
                                            height: "200px",
                                            borderRadius: "8px",
                                            border: "1px solid ".concat(colors.greyShades[18]),
                                        } })))),
                            React.createElement(Stack, { direction: "row", spacing: 2 },
                                React.createElement(Button, { variant: "outlined", sx: {
                                        textTransform: "none",
                                        borderColor: colors.greyShades[18],
                                        color: "text.primary",
                                    }, onClick: handleCancelEdit }, "Cancel"),
                                React.createElement(Button, { variant: "contained", sx: { textTransform: "none" }, onClick: handleSaveFaq }, "Save FAQ")))),
                        faqs.map(function (faq) {
                            return editingFaqId === faq.id ? (React.createElement(Stack, { key: faq.id, sx: {
                                    border: "1px dashed ".concat(colors.greyShades[18]),
                                    borderRadius: 2,
                                    p: 2,
                                    gap: 2,
                                } },
                                React.createElement(Stack, { spacing: 0.5 },
                                    React.createElement(Typography, { fontSize: 14, fontWeight: 500 },
                                        "Question ",
                                        React.createElement("span", { style: { color: "red" } }, "*")),
                                    React.createElement(RichTextEditor, { value: question, maxLength: 200, onChange: function (html) {
                                            var plainTextLength = getPlainTextLength(html);
                                            if (plainTextLength <= 200) {
                                                setQuestion(html);
                                            }
                                        } }),
                                    React.createElement(Typography, { fontSize: 12, color: "text.secondary", textAlign: "start" },
                                        getPlainTextLength(question),
                                        " / 200 characters")),
                                React.createElement(Stack, { spacing: 0.5 },
                                    React.createElement(Typography, { fontSize: 14, fontWeight: 500 },
                                        "Answer ",
                                        React.createElement("span", { style: { color: "red" } }, "*")),
                                    React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center", justifyContent: "flex-end", sx: { mb: 1 } },
                                        (answerUpload || existingAnswerImagePath) && (React.createElement(Stack, { direction: "row", spacing: 0.5, alignItems: "center" },
                                            React.createElement(Typography, { variant: "caption" }, answerUpload
                                                ? answerUpload.name
                                                : existingAnswerImagePath),
                                            React.createElement(IconButton, { size: "small", onClick: function () {
                                                    setAnswerUpload(null);
                                                    setExistingAnswerImagePath("");
                                                    if (editingFaqId !== null) {
                                                        setImageRemovedInEdit(true);
                                                    }
                                                }, sx: { p: 0.5 } },
                                                React.createElement(CloseIcon, { fontSize: "small" })))),
                                        React.createElement(Stack, { spacing: 0.25, alignItems: "flex-end" },
                                            React.createElement(Button, { component: "label", variant: "outlined", startIcon: React.createElement(CloudUploadIcon, null), sx: { textTransform: "none" } },
                                                "Upload File",
                                                React.createElement(VisuallyHiddenInput, { type: "file", multiple: false, onChange: handleAnswerUpload })),
                                            React.createElement(Typography, { variant: "caption", color: "text.secondary", sx: { textAlign: "right" } }, "Supported: JPG, PNG (25MB max)"))),
                                    React.createElement(RichTextEditor, { value: content, maxLength: 2000, onChange: function (html) {
                                            console.log("RichTextEditor onChange - HTML:", html);
                                            var plainTextLength = getPlainTextLength(html);
                                            if (plainTextLength <= 2000) {
                                                setContent(html);
                                            }
                                        } }),
                                    React.createElement(Typography, { fontSize: 12, color: getPlainTextLength(content) > 2000
                                            ? "error"
                                            : "text.secondary", textAlign: "start", sx: { mt: 1 } },
                                        getPlainTextLength(content),
                                        " / 2000 characters"),
                                    (answerUpload || existingAnswerImagePath) && (React.createElement(Box, { sx: { mb: 1 } },
                                        React.createElement("img", { src: answerUpload
                                                ? URL.createObjectURL(answerUpload)
                                                : getImageUrl(existingAnswerImagePath), alt: "FAQ attachment preview", style: {
                                                maxWidth: "200px",
                                                height: "200px",
                                                borderRadius: "8px",
                                                border: "1px solid ".concat(colors.greyShades[18]),
                                            } })))),
                                React.createElement(Stack, { direction: "row", spacing: 2 },
                                    React.createElement(Button, { variant: "outlined", sx: {
                                            textTransform: "none",
                                            borderColor: colors.greyShades[18],
                                            color: "text.primary",
                                        }, onClick: handleCancelEdit }, "Cancel"),
                                    React.createElement(Button, { variant: "contained", sx: { textTransform: "none" }, onClick: handleSaveFaq }, "Update FAQ")))) : (React.createElement(Accordion, { key: faq.id, sx: {
                                    bgcolor: colors.fullWhite,
                                    borderRadius: "8px !important",
                                    boxShadow: "none",
                                    border: "1px dashed ".concat(colors.greyShades[18]),
                                    "&:before": { display: "none" },
                                    "&.Mui-expanded": { margin: 0 },
                                } },
                                React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null), sx: {
                                        "& .MuiAccordionSummary-content": {
                                            margin: 0,
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        },
                                        "&.Mui-expanded": {
                                            borderBottom: "1px solid ".concat(colors.greyShades[18]),
                                        },
                                    } },
                                    React.createElement(Box, { sx: {
                                            fontWeight: 600,
                                            fontSize: 14,
                                            "& p": { margin: 0 },
                                            "& ol, & ul": { pl: 2 },
                                        }, dangerouslySetInnerHTML: { __html: faq.question } })),
                                React.createElement(AccordionDetails, { sx: { padding: "16px" } },
                                    React.createElement(Box, { sx: {
                                            fontSize: 13,
                                            color: "text.secondary",
                                            "& p": { margin: 0 },
                                            "& img": { maxWidth: "200px", height: "200px" },
                                            "& a": {
                                                color: "#1976d2",
                                                textDecoration: "underline",
                                                "&:visited": {
                                                    color: "#1976d2",
                                                },
                                                "&:hover": {
                                                    color: "#1565c0",
                                                },
                                                "&:active": {
                                                    color: "#1976d2",
                                                },
                                            },
                                        }, dangerouslySetInnerHTML: { __html: faq.answer } }),
                                    faq.answerUpload && (React.createElement(Box, { sx: { mt: 2 } },
                                        React.createElement("img", { src: getImageUrl(faq.answerUpload), alt: "FAQ attachment", style: {
                                                maxWidth: "200px",
                                                height: "200px",
                                                borderRadius: "8px",
                                                border: "1px solid ".concat(colors.greyShades[18]),
                                            } }))),
                                    faqPerms.canView && (faqPerms.canEdit || faqPerms.canDelete) && (React.createElement(Stack, { direction: "row", spacing: 1, sx: { mt: 1.5, justifyContent: "flex-start" } },
                                        faqPerms.canEdit && (React.createElement(Button, { variant: "outlined", size: "small", startIcon: React.createElement(EditOutlinedIcon, null), sx: { textTransform: "none" }, onClick: function () { return handleEditFaq(faq); } }, "Edit")),
                                        faqPerms.canDelete && (React.createElement(Button, { variant: "outlined", size: "small", startIcon: React.createElement(DeleteOutlineOutlinedIcon, null), sx: {
                                                textTransform: "none",
                                                borderColor: colors.errorShades[10],
                                                color: colors.errorShades[10],
                                                "&:hover": {
                                                    borderColor: colors.errorShades[10],
                                                    color: colors.errorShades[10],
                                                },
                                            }, onClick: function () { return handleDeleteFaq(faq.id); } }, "Delete")))))));
                        }))))))),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, titleText: "Delete FAQ", message: "Are you sure you want to delete this FAQ?", acceptBtnText: "Yes", denyBtnText: "No", open: deleteConfirmationOpen, acceptCallBack: handleConfirmDeleteFaq, denyCallBack: handleCancelDeleteFaq, cancelCallBack: handleCancelDeleteFaq, swapButtonOrder: true })));
};
export default CustomerPortalBrandCustomization;
